import React from "react";
import PropTypes from "prop-types";
import { Elements } from "@stripe/react-stripe-js";
import useStripeElements from "./use-stripe-elements";

// Wraps a Stripe retail payment surface. Renders its children inside Stripe's
// <Elements> provider once the deferred PaymentElement can safely mount.

// `children` is a render prop called with `ready`, because both this component
// (whether to wrap in <Elements>) and the children (whether the PaymentElement
// can safely mount yet) need to know it:
//
//   <StripeElementsProvider enabled={flag} amount={total} publishableKey={key}
//     customerSessionPath={path}>
//     {ready => <PaymentForm stripeReady={ready} />}
//   </StripeElementsProvider>
const StripeElementsProvider = ({
  publishableKey = null,
  enabled = true,
  amount = null,
  customerSessionPath = null,
  paymentMethodsConfigId = null,
  buildOptions = undefined,
  children
}) => {
  const { stripePromise, elementsOptions, ready } = useStripeElements({
    publishableKey,
    enabled,
    amount,
    customerSessionPath,
    paymentMethodsConfigId,
    buildOptions
  });

  const content = children(ready);

  if (ready) {
    return (
      <Elements stripe={stripePromise} options={elementsOptions}>
        {content}
      </Elements>
    );
  }

  return content;
};

StripeElementsProvider.propTypes = {
  publishableKey: PropTypes.string,
  enabled: PropTypes.bool,
  amount: PropTypes.number,
  customerSessionPath: PropTypes.string,
  paymentMethodsConfigId: PropTypes.string,
  buildOptions: PropTypes.func,
  children: PropTypes.func.isRequired
};

export default StripeElementsProvider;
